
export default {
    namespaced: true,
    state: {
        rolesData: [],
        sectionsList: [],
        isFail: false,
        isLoad: false,
        forSaveRoles: {},
        roles: [],
        editToggle: {}

    },
    getters: {
        ROLES: state => {
            return state.roles;
        },
        EDIT_TOGGLE: state => {
            return state.editToggle;
        },
        FOR_SAVE_ROLES: state => {
            return state.forSaveRoles;
        },
        IS_LOAD: state => {
            return state.isLoad;
        },
        IS_FAIL: state => {
            return state.isFail;
        },
        ROLES_DATA: state => {
            return state.rolesData;
        },
        SECTIONS_LIST: state => {
            return state.sectionsList;
        },
    },
    mutations: {
        EDIT_TOGGLE: (state, payload) => {
            return state.editToggle = payload;
        },
        ROLES: (state, payload) => {
            return state.roles = payload;
        },
        FOR_SAVE_ROLES: (state, payload) => {
            return state.forSaveRoles = payload;
        },
        IS_LOAD: (state, payload) => {
            return state.isLoad = payload;
        },
        IS_FAIL: (state, payload) => {
            return state.isFail = payload;
        },
        ROLES_DATA: (state, payload) => {
            return state.rolesData = payload;
        },
        SECTIONS_LIST: (state, payload) => {
            return state.sectionsList = payload;
        },
    },
    actions: {
        GET_ALL: async ({state, rootGetters }) => {
            let {data} = await rootGetters.getHttpClient.get('/roles/get');
            if (data.status == 'success') {
                state.isLoad = true;
                state.sectionsList = data.sections
                state.isFail = false;
                for (let key in data.rolesData) {
                    data.rolesData[key]['action'] = '';
                }
                state.rolesData = data.rolesData;
            } else {
                state.isFail = true;
            }
        },
        SAVE: async ({state, commit, dispatch, rootGetters }) => {
            await rootGetters.getHttpClient.post('/roles/save', state.forSaveRoles
            ).then(function(response) {
                let responseData = response.data;
                if (responseData.status == 'success') {
                    state.forSaveRoles = {};
                    dispatch('GET_ALL');
                    commit('setInfoText', 'Данные сохранены!', {root: true});
                    rootGetters.getBvModal.show('infoMessage');
                } else {
                    // show error
                    commit('setErrorText', responseData.errorInfo, {root: true});
                    rootGetters.getBvModal.show('errorResponse');
                }
            }).catch(function(error) {
                commit('setErrorText', error.toString(), {root: true});
                rootGetters.getBvModal.show('errorResponse');
            });
        }
    }
}